<template>
  <div id="YourCoach">
    <b-modal
      v-if="bannerData"
      id="good-morning-modal"
      size="lg"
      v-bind:modal-class="'good-morning-modal ' + getTheme()"
      hide-footer
      hide-header
    >
      <div class="title">Hello<span v-if="userName" class="brand-primary"> {{userName}}</span>, how can we help today?</div>
      <div class="navigation-cards">
        <NavigationCard
          @click="handleSelection"
          :optionNumber="optionNumber"
          :borderColor="optionNumber === item.id? '2px solid var(--brand-primary)' : '1px solid #E0E5F5'"
          v-for="item in bannerData.items"
          :id="item.id"
          :description='item.description'
          :icon="item.icon"
        />
      </div>
      <div class="checkbox-container">
        <input
          type="checkbox"
          id="agree-checkbox"
          v-model="doNotShowAgain"
          aria-label="Agree to privacy policy"
          class="checkbox"
        />
        <label for="agree-checkbox" class="checkbox-text">
          Don't show this window again.
        </label>
      </div>
      <b-button
        @click="handleRedirect"
        class="button bg-brand-primary">
        {{optionSelected ? "Continue" : "Take me to the homepage"}}
      </b-button>
    </b-modal>
  
  </div>

</template>

<script>
import NavigationCard from "@/components/Home/New/NavigationCard.vue";
import axios from "axios";
import config from "../../../config/constants";

export default {
  components: {
    NavigationCard
  },
  name: "HomeStartModal",
  data() {
    return {
      doNotShowAgain: false,
      bannerData: null,
      optionSelected: false,
      optionNumber: null
    };
  },
  computed: {
    userName() {
      return this.$store.getters.user.user.first_name || null;
    }
  },
  async mounted() {
    await this.getGoodMorningBanner();
    if (this.$route.query.personalise_banner === 'true') {
      this.$bvModal.hide("good-morning-modal");
    } else {
      this.$bvModal.show("good-morning-modal");
    }
  },
  methods: {
    handleSelection(key) {
      if (this.optionSelected) {
        if (this.optionNumber === key) {
          this.optionSelected = false;
          this.optionNumber = null;
        } else {
          this.optionNumber = key;
        }
      } else {
        this.optionSelected = true;
        this.optionNumber = key;
      }
    },
    async getGoodMorningBanner() {
      const payload = {
        user_id: this.$store.getters.user_id
      };
      const res = await axios.post(config.api_env + "/application/api/u/marketplace/get-good-morning-banner", payload, config.options);
      if (res.data.success && res.data.banner) {
        this.bannerData = res.data.banner;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
    async handleRedirect() {
      if(this.doNotShowAgain) await this.setBanner();
      if (this.optionSelected) {
        const link = this.bannerData.items.find((banner) => banner.id === this.optionNumber).url;
        await this.$router.push(link);
      }
      this.$bvModal.hide("good-morning-modal");
    },
    async setBanner() {
      const payload = {
        user_id: this.$store.getters.user_id,
        banner_name: "good_morning",
        set_show: !this.doNotShowAgain
      };
      const res = await axios.post(config.api_env + "/application/api/u/user/set-banner", payload, config.options);
      if (res.data.success) {
        localStorage.setItem("goodMorningBanner", !this.doNotShowAgain);
      }
    }
  }
};
</script>
<style lang="less">

#good-morning-modal {
  border-radius: 10px;
  .modal-body {
    padding: 40px;
    display: flex;
    flex-direction: column;
  }
  
  .modal-content {
    border-radius: 0;
    overflow: auto;
    max-height: 90vh;
    max-width: 90vh;
  }
  
  .title {
    font-size: 32px;
    text-align: center;
    line-height: 36px;
    font-weight: bolder;
    font-family: "Raptor V3 Black";
    margin-bottom: 40px;
  }
  
  .navigation-cards {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 27px;
    margin-bottom: 40px;
    max-height: 50vh;
    overflow-y: scroll;
  }
  
  .checkbox-container {
    display: flex;
    justify-content: flex-start;
    gap: 14px;
    margin: 0 0 32px 40px;
  }
  
  .checkbox {
    cursor: pointer;
    width: 28px;
    height: 28px;
    font-family: "DMSans";
    
    &:before {
      content: "";
      display: block;
      width: 28px;
      background-color: #fff;
      border: 3px solid var(--brand-primary);
      height: 28px;
    }
    
    &:checked:before {
      content: "✔";
      font-size: 2rem;
      line-height: 2rem;
      padding: 2px;
      color: #fff;
      background-color: var(--brand-primary);
    }
  }
  
  .checkbox-text {
    font-size: 18px;
    cursor: pointer;
    margin: 0;
  }
  
  .button {
    align-self: center;
    border-radius: 5px;
    padding: 12px 20px;
    color: #ffffff;
    font-size: 16px;
    border: none;
    margin-bottom: 40px;
    font-family: "Raptor V3 Black";
  }
}
</style>
